import { render, staticRenderFns } from "./oldVersions.vue?vue&type=template&id=5de157c2"
import script from "./oldVersions.vue?vue&type=script&lang=js"
export * from "./oldVersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports